export default "__VITE_ASSET__DCEe2uit__"